import { Card, Descriptions, Typography } from "antd";
import React from "react";
import { CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewFieldsFragment } from "../../../../../../generated";
import { DATE_TIME_FORMAT, FormatDate } from "../../../../../../constants";

export interface AffirmationsSummaryProps {
  caseApplicationReviewData: CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewFieldsFragment;
}

export const AffirmationsSummary: React.FC<AffirmationsSummaryProps> = (
  props
) => {

  return (
    <div>
      <Card>
        <Typography.Text style={{ fontSize: '20px' }}>Affirmations</Typography.Text>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6 items-start w-full" style={{ marginTop: '10px' }}>
          <div className="flex flex-col space-y-6">
            <Descriptions
              title={<Typography.Text style={{ fontSize: '16px' }}>Credential Review</Typography.Text>}
              layout="vertical"
              size="small"
              column={2}
              className="w-[400px]"
              style={{ marginTop: 10 }}
            >
              <Descriptions.Item label="Completed By">{props.caseApplicationReviewData?.affirmations?.audit?.completedBy?.displayName?.toString() ?? 'N/A'}</Descriptions.Item>
              <Descriptions.Item label="Result">{props.caseApplicationReviewData?.affirmations?.audit?.result ?? 'N/A'}</Descriptions.Item>
              <Descriptions.Item label="Completed At">
                {props.caseApplicationReviewData?.affirmations?.audit?.completedAt
                  ? FormatDate(props.caseApplicationReviewData?.affirmations?.audit?.completedAt, DATE_TIME_FORMAT)
                  : 'N/A'}
              </Descriptions.Item>
            </Descriptions>
          </div>
          <div className="flex flex-col space-y-6">
            {/* <Typography.Text style={{ fontSize: '16px' }}>Verification Review</Typography.Text> */}
            <Descriptions
              layout="vertical"
              size="small"
              column={2}
              className="w-[600px]"
              style={{ marginTop: 10 }}
              title={<Typography.Text style={{ fontSize: '16px' }}>Verification Review</Typography.Text>}
            >
              <Descriptions.Item label="Completed By">
                {props.caseApplicationReviewData?.verificationAffirmations?.audit?.completedBy?.displayName?.toString() ?? 'N/A'}
              </Descriptions.Item>
              <Descriptions.Item label="Result">{props.caseApplicationReviewData?.verificationAffirmations?.audit?.result ?? "N/A"}</Descriptions.Item>
              <Descriptions.Item label="Completed At">
                {props.caseApplicationReviewData?.verificationAffirmations?.audit?.completedAt
                  ? FormatDate(props.caseApplicationReviewData?.verificationAffirmations?.audit?.completedAt, DATE_TIME_FORMAT)
                  : 'N/A'}
              </Descriptions.Item>
            </Descriptions>
          </div>
        </div>
      </Card>
    </div>
  );
};
